/**
 * @file paddle 教程
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback, useRef} from 'react';
import Icon from '@ant-design/icons';
import classNames from 'classnames';


import Header from '../../components/header/HeaderWithStore';
import Footer from '../../components/footer/footer';
import GroupMenu from './components/menu/GroupMenu';
import ReactStickyPolyfill from '../../components/react-sticky-polyfill/ReactStickyPolyfill';
import useTutorialsHooks from './tutorialsHooks';
import LessonMenu from './components/menu/LessonMenu';
import RightMenu from './components/right-menu/RightMenu';
import DocBreadcrumb from './components/menu/DocBreadcrumb';
import DocRate from '../../components/document-rate/rate';

import {ReactComponent as IconRunOnline} from './image/runonline.svg';
// import {ReactComponent as IconDownloadNotebook} from './image/downloadnotebook.svg';
// import {ReactComponent as IconGithub} from './image/github.svg';

import {ITutorialsProps} from './type.d';
import ProjectDetail from './components/project-detail/ProjectDetail';
import VersionSelect from './components/menu/VersionSelect';

const Tutorials: React.FC<ITutorialsProps> = () => {
    const {
        lessonProjectId,

        projectContentHooks,
        menuHooks,
        rightMenuHooks,
        breadcrumbsListHook,
        rateHook
    } = useTutorialsHooks();

    const pageMainRef = useRef<HTMLDivElement>(null);
    const topRef = useRef<HTMLDivElement>(null);

    const topSelectContainer = useCallback(() => {
        return topRef.current || document.querySelector('.paddle-tutorials-top');
    }, []);


    return (
        <div className="page paddle-tutorials-page">
            <Header />
            <ReactStickyPolyfill>
                <div className="paddle-tutorials-top" ref={topRef}>
                    <div className="paddle-tutorials-top-inner">
                        {/* <div className="paddle-tutorials-version-select-wrap">
                            <VersionSelect
                                value={menuHooks.versionSelectedKey}
                                onChange={menuHooks.onVersionChange}
                                versionList={menuHooks.versionList}
                            />
                        </div> */}
                        <GroupMenu
                            getPopupContainer={topSelectContainer}
                            menuList={menuHooks.groupList}
                            selectedKey={menuHooks.groupSelectedKey}
                            onSelect={menuHooks.onGroupSelect}
                        />
                    </div>
                </div>
            </ReactStickyPolyfill>
            <div className={
                classNames(
                    'paddle-tutorials-container',
                    {
                        'paddle-tutorials-container-no-left': menuHooks.lessonList.length === 0,
                        'paddle-tutorials-container-no-right': rightMenuHooks.menuList.length === 0
                    }
                )}
            >
                <div
                    className={classNames(
                        'paddle-tutorials-main',
                        {
                            'paddle-tutorials-left-menu-show': menuHooks.leftMenuShow,
                            'paddle-tutorials-left-menu-display': menuHooks.lessonList.length > 0
                        }
                    )}
                    ref={pageMainRef}
                >
                    <div className="paddle-tutorials-left-background" />
                    <div className="paddle-tutorials-left">
                        <ReactStickyPolyfill>
                            <div className="paddle-tutorials-left-menu-wrap">
                                <LessonMenu
                                    openKeys={menuHooks.lessonOpenKeys}
                                    selectedKeys={menuHooks.lessonSelectedKeys}
                                    menuList={menuHooks.lessonList}
                                    onSelect={menuHooks.onLessionSelect}
                                    onOpenKeysChange={menuHooks.onLessonOpenKeysChange}
                                />
                            </div>
                        </ReactStickyPolyfill>
                    </div>

                    <div className="paddle-tutorials-right">
                        <ReactStickyPolyfill>
                            <div className="paddle-tutorials-right-menu-wrap">
                                <div className="paddle-tutorials-right-menu-index">
                                    目录
                                </div>
                                <RightMenu
                                    openKeys={rightMenuHooks.openKeys}
                                    selectedKeys={rightMenuHooks.selectedKeys}
                                    menuList={rightMenuHooks.menuList}
                                />
                            </div>
                        </ReactStickyPolyfill>
                    </div>

                    <div className="paddle-tutorials-center">
                        {menuHooks.groupList.length > 0
                        && (
                            <ReactStickyPolyfill>
                                <div className="paddle-tutorials-left-menu-switch-wrap">
                                    <div
                                        className="paddle-tutorials-left-menu-switch"
                                        onClick={menuHooks.toogleLeftMenuShow}
                                    />
                                </div>
                            </ReactStickyPolyfill>
                        )}
                        <div className="paddle-tutorials-breadcrumb-wrap clear-both">
                            <DocBreadcrumb
                                breadcrumbsList={breadcrumbsListHook.breadcrumbsList}
                            />
                            <div className="paddle-tutorials-breadcrumb-wrap-right">
                                <DocRate
                                    value={rateHook.rateValue}
                                    onChange={rateHook.submitRate}
                                />
                            </div>
                        </div>

                        <div className="paddle-tutorials-goto-group">
                            {!!lessonProjectId
                            && (
                                <a
                                    className="paddle-tutorials-goto"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`https://aistudio.baidu.com/studio/edu/group/quick/join/${lessonProjectId}`}
                                >
                                    <Icon component={IconRunOnline as any} />
                                    <span>在线运行代码</span>
                                </a>
                            )}

                            {/*{!!lessonProjectId*/}
                            {/*&& (*/}
                            {/*    <a*/}
                            {/*        className="paddle-tutorials-goto"*/}
                            {/*        target="_blank"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        href={`https://aistudio.baidu.com/studio/edu/group/quick/join/${lessonProjectId}`}*/}
                            {/*    >*/}
                            {/*        <Icon component={IconDownloadNotebook as any} />*/}
                            {/*        <span>下载Notebook</span>*/}
                            {/*    </a>*/}
                            {/*)}*/}
                            {/*{!!lessonProjectId*/}
                            {/*&& (*/}
                            {/*    <a*/}
                            {/*        className="paddle-tutorials-goto"*/}
                            {/*        target="_blank"*/}
                            {/*        rel="noopener noreferrer"*/}
                            {/*        href=""*/}
                            {/*    >*/}
                            {/*        <Icon component={IconGithub as any} />*/}
                            {/*        <span>在Github查看源码</span>*/}
                            {/*    </a>*/}
                            {/*)}*/}
                        </div>
                        <div
                            className="paddle-tutorials-content markdown-body"
                            ref={rightMenuHooks.contentDomRef}
                        >
                            <ProjectDetail {...projectContentHooks} />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Tutorials;
